import { useCallback } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';
import Share from '@gef-ui/material-icons/Share';

import { KCL_HANDOVER_RA_ANALYSES } from 'features/common/acl/constants';
import { openHandoverModal } from 'features/views/roboAdvisory/roboAdvisoryHandover/actions';
import { getIsAnyRaAnalysisSelected } from 'features/views/roboAdvisory/selectors';
import { getHasSubordinates } from 'features/views/user/selectors';

export const RAActionButtons = () => {
	const dispatch = useDispatch();
	const hasSubordinates = useSelector(getHasSubordinates);
	const atLeastOneRaRecordSelected = useSelector(getIsAnyRaAnalysisSelected);

	const handleOpenHandoverModal = useCallback(() => {
		dispatch(openHandoverModal());
	}, [dispatch]);

	return (
		<AccessControl accessLevel={KCL_HANDOVER_RA_ANALYSES}>
			{hasSubordinates && (
				<Button
					variant="text"
					onClick={handleOpenHandoverModal}
					startIcon={<Share />}
					disabled={!atLeastOneRaRecordSelected}
				>
					{getLabelMessage('roboAdvisory:handOverRAAnalysis')}
				</Button>
			)}
		</AccessControl>
	);
};

export default RAActionButtons;
